// A country's flag for the "Country-focused" chips, from the country names the
// refresh job uses (scripts/refresh/lib/country-focus.mjs). Small pictures in
// public/flags/, made from the flag-icons set (MIT, LICENSE.txt there), so
// every system draws the same flag; emoji flags looked out of place beside
// the site's own icons, and some systems draw them as two letters (owner,
// 2026-10-17). The chip still names the country.

const CODES = {
  Afghanistan: 'AF',
  Albania: 'AL',
  Algeria: 'DZ',
  Argentina: 'AR',
  Armenia: 'AM',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bangladesh: 'BD',
  Belarus: 'BY',
  Belgium: 'BE',
  Bolivia: 'BO',
  Bosnia: 'BA',
  Brazil: 'BR',
  Bulgaria: 'BG',
  Cambodia: 'KH',
  Canada: 'CA',
  Chile: 'CL',
  China: 'CN',
  Colombia: 'CO',
  Croatia: 'HR',
  Cuba: 'CU',
  Cyprus: 'CY',
  Czechia: 'CZ',
  Denmark: 'DK',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  Estonia: 'EE',
  Ethiopia: 'ET',
  Finland: 'FI',
  France: 'FR',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Greece: 'GR',
  Guatemala: 'GT',
  Haiti: 'HT',
  Honduras: 'HN',
  Hungary: 'HU',
  India: 'IN',
  Indonesia: 'ID',
  Iran: 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Korea: 'KR',
  Kosovo: 'XK',
  Latvia: 'LV',
  Lebanon: 'LB',
  Libya: 'LY',
  Lithuania: 'LT',
  Malaysia: 'MY',
  Mexico: 'MX',
  Moldova: 'MD',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Morocco: 'MA',
  Nepal: 'NP',
  Netherlands: 'NL',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Nigeria: 'NG',
  Norway: 'NO',
  Pakistan: 'PK',
  Palestine: 'PS',
  Panama: 'PA',
  Peru: 'PE',
  Philippines: 'PH',
  Poland: 'PL',
  Portugal: 'PT',
  Qatar: 'QA',
  Romania: 'RO',
  Russia: 'RU',
  Rwanda: 'RW',
  'Saudi Arabia': 'SA',
  Serbia: 'RS',
  Singapore: 'SG',
  Slovakia: 'SK',
  Slovenia: 'SI',
  Somalia: 'SO',
  'South Africa': 'ZA',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Sweden: 'SE',
  Switzerland: 'CH',
  Syria: 'SY',
  Taiwan: 'TW',
  Thailand: 'TH',
  Turkey: 'TR',
  Ukraine: 'UA',
  'United Kingdom': 'GB',
  Uzbekistan: 'UZ',
  Venezuela: 'VE',
  Vietnam: 'VN',
  Yemen: 'YE',
};

/** "/flags/il.png" for "Israel"; '' for a name we don't know */
export function flagSrc(country) {
  const code = CODES[country];
  return code ? `/flags/${code.toLowerCase()}.png` : '';
}
